import{a as r,b as c}from"./chunk-OWBHRN3S.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();var v=(n,h)=>{var e;let{hash:i}=r(),t=i.split("/"),s=t[0]?t[0].replace("#",""):"",g=(e=t[1])!=null?e:0;return s===h&&n.order===Number(g)};export{v as a};
//# sourceMappingURL=chunk-HIGMC5II.js.map
